import { render, staticRenderFns } from "./MatchHSAndGSRP.vue?vue&type=template&id=75977fa2&"
import script from "./MatchHSAndGSRP.vue?vue&type=script&lang=ts&"
export * from "./MatchHSAndGSRP.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports